import * as React from 'react'

import { List } from '@factorialco/deprecated-design-system'
import { AtsFileFragment } from 'generated/resources/graphql'

import { OtherFilesItem } from './OtherFilesItem'

interface Props {
  files: AtsFileFragment[]
}

export const OtherFilesList = ({ files }: Props) => {
  if (!files || !files.length) {
    return null
  }

  return (
    <List>
      {files.map((atsFile) => (
        <OtherFilesItem key={atsFile.id} atsFile={atsFile} />
      ))}
    </List>
  )
}
